import React, { useState, useEffect } from "react";
import { useTimer } from "../context/TimerContext";

/**
 * A standalone component for showing a running timer
 * Shows loading state until server data is available
 */
const TimerClock = ({ timeEntryId }) => {
  const { currentTimer, formattedTime, isLoading, refreshCurrentTimer } =
    useTimer();
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // Actively refresh the timer on component mount
  useEffect(() => {
    const fetchTimer = async () => {
      await refreshCurrentTimer();
      setIsInitialLoad(false);
    };

    if (isInitialLoad) {
      console.log("Initial timer load, refreshing from server...");
      fetchTimer();
    }
  }, [refreshCurrentTimer, isInitialLoad]);

  // Log when timer data changes
  useEffect(() => {
    if (currentTimer) {
      console.log("Timer data updated:", {
        formattedTime,
        status: currentTimer.status,
        active_time: currentTimer.active_elapsed_formatted,
      });
    }
  }, [currentTimer, formattedTime]);

  // On initial load, show a loading indicator until the first refresh completes
  if (isLoading && isInitialLoad) {
    return <span className="font-mono">Loading...</span>;
  }
  // Always display the client‑computed formatted time
  return <span className="font-mono">{formattedTime}</span>;
};

export default TimerClock;
